import { getLanguageLabel } from '../../../helper/language';

export enum UserLanguage {
  ENGLISH = 'en',
}

export const UserLanguageList = [{ name: getLanguageLabel(UserLanguage.ENGLISH), value: UserLanguage.ENGLISH }];
